import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  "aria-label": "pagination",
  class: "pagination"
}
const _hoisted_2 = ["aria-hidden"]
const _hoisted_3 = {
  key: 2,
  class: "px-2"
}
const _hoisted_4 = {
  key: 3,
  class: "px-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_ctx.hasMorePages)
    ? (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            "aria-hidden": link.url ? false : true,
            class: _normalizeClass(["pagination__item", _ctx.getItemClasses(link)])
          }, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(link.url ? 'InertiaLink' : 'p'), {
              href: link.url,
              "preserve-state": "",
              only: _ctx.only,
              "preserve-scroll": _ctx.preserveScroll
            }, {
              default: _withCtx(() => [
                (link.label === '<')
                  ? (_openBlock(), _createBlock(_component_SvgIcon, {
                      key: 0,
                      type: "mdi",
                      path: _ctx.leftIcon
                    }, null, 8, ["path"]))
                  : (link.label === '>')
                    ? (_openBlock(), _createBlock(_component_SvgIcon, {
                        key: 1,
                        type: "mdi",
                        path: _ctx.rightIcon
                      }, null, 8, ["path"]))
                    : (_ctx.onEachSide > 0 || !link.active)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(link.label), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(link.label) + " av " + _toDisplayString(_ctx.lastPage), 1))
              ]),
              _: 2
            }, 1032, ["href", "only", "preserve-scroll"]))
          ], 10, _hoisted_2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}